import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahslab',
  templateUrl: './asahslab.component.html',
  styleUrls: ['./asahslab.component.scss']
})
export class AsahslabComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
